import { Component, Output, EventEmitter } from '@angular/core';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';

@Component({
  selector: 'aig-modal-already-cancelled',
  imports: [
    ModalComponent
  ],
  templateUrl: './modal-already-cancelled.component.html',
  styleUrl: './modal-already-cancelled.component.scss'
})
export class ModalAlreadyCancelledComponent {

  //#region INPUTS & OUTPUTS
  @Output() hideModal: EventEmitter<boolean> = new EventEmitter<boolean>();
  clickHide(): void {
    this.hideModal.emit(true);
  }

  //#endregion

  public email: string = "backoffice.caixa@icp.es";
}
